import React,{ useState, useEffect } from 'react';
import styled from 'styled-components';
import {  useHistory } from 'react-router-dom';
import { useMutation, useQuery } from '@apollo/client';
import { useForm } from 'react-hook-form';
import { If, Then, Else} from 'react-if';
import { textAreaStyle } from '../styles/includes/forms'

// Components
import StyledPage from '../components/StyledPage';

import Loading from '../components/Loading';
import Label from '../components/InputLabel';
import OptionList from '../components/InputOptionList';
import Button from '../components/Button';
import AuthLayoutWrapper from '../components/AuthLayoutWrapper';
import FormErrors, { trowError } from '../components/FormErrors';

import AcreditacionProfile, { GET_PROFILE } from '../models/AcreditacionProfile';
import { CREATE_ACREDITACION_PROFILE_ATTENTION_PERSONAL } from '../models/AcreditacionProfileAttentionPersonal';


//Assets
import iconEdit from '../assets/icons/edit.svg';


const StyledForm = styled.form`
  h1 {
    margin-bottom: 2.5rem;
  }
  h4 {
    font-size:15px;
    color: #000;
    margin: 1.3rem 0;
    strong{
      color:#f10000;
    }
  }
  textarea {
    ${textAreaStyle}
    width: 100%;
    height: 80px;
    padding: 12px;
  }
  .field {
  }
  .page-footer {
    text-align: center;
    margin-top: 2rem
  }
  .sample-photo {
    max-width: 120px;
    margin: auto;
    img {
      box-shadow: var(--base-box-shadow);
      width: 100%;
    }
  }
`

const FieldRadio= styled.div`
  display:grid;
  grid-template-columns:20px auto;
  gap:10px;
  label{
    cursor: pointer;
    margin-bottom:0px;
  }
  margin-bottom:7px;
`;

export default  () => {
    let history = useHistory();
    let UserInfo=AcreditacionProfile.getProfile();
  
    const { control, register, handleSubmit, reset, watch } = useForm();
    const subscriptionRazon = watch('razon');

    const [ createProfileAttention, { loading:loadingProfileAttention }] = useMutation(CREATE_ACREDITACION_PROFILE_ATTENTION_PERSONAL);


    const [showConfirm,setshowConfirm] = useState<boolean>(false);
    const [submitError,setSubmitError] = useState<null|string>(null);

    const { loading, error, data } = useQuery(GET_PROFILE,{
        variables:{
            profile_uuid:UserInfo.uuid,
        }
    });

    const onSubmit = async (data:any) => {
        console.log('on Send data:',data);
        try{            
            let response=await createProfileAttention({ 
                variables:{
                    profile_uuid:UserInfo.uuid,
                    input:{
                        ...data
                    }
                },
                context:{
                    headers:{
                        'x-recapchatoken':''
                    }
                }                
            });

            if(response.errors)
                throw new trowError(response.errors);

            setshowConfirm(true);
        }catch(e){
            console.error(e);
            setSubmitError(e);
            window.scrollTo(0,0);
        }
    }



    if(loading)
        return <Loading />

    let profile=data.getAcreditacionProfile;

    return (
        <StyledPage>
            <div className='grid'>
                <If condition={!showConfirm}>
                    <Then>
                        {submitError?<div className="error-message"><FormErrors errors={submitError} /></div>:null}

                        <StyledForm onSubmit={handleSubmit(onSubmit)}>
                            <h1>Atención personal</h1>

                            <div>
                                <h4>¿En qué te podemos apoyar?<strong>*</strong></h4>
                                <FieldRadio>
                                    <input id="razon_1" name="razon"  value="Dudas de los beneficios" type="radio" ref={register} required />
                                    <Label htmlFor='razon_1'>Dudas de los beneficios</Label>
                                </FieldRadio> 
                                <FieldRadio>
                                    <input id="razon_2" name="razon"  value="Dudas de los asientos" type="radio" ref={register}  required/>
                                    <Label htmlFor='razon_2'>Dudas de los asientos</Label>
                                </FieldRadio>  
                                <FieldRadio>
                                    <input  id="razon_3" name="razon"  value="Quejas o comentarios" type="radio" ref={register} required/>
                                    <Label htmlFor='razon_3'>Quejas o comentarios</Label>
                                </FieldRadio>
                                <FieldRadio>
                                    <input  id="razon_4" name="razon"  value="Otros" type="radio" ref={register} required />
                                    <Label htmlFor='razon_4'>Otros</Label>
                                </FieldRadio>
                                {subscriptionRazon=='Otros' &&    
                      <div>
                          <textarea name="razon_cual" ref={register} placeholder='¿Cuales?'></textarea>
                      </div>                   
                                }                                                  
                            </div>

                            <div>
                                <h4>¿Cómo prefieres la atención?<strong>*</strong></h4>
                                <FieldRadio>
                                    <input id="forma_1" name="forma"  value="Whatsapp" type="radio" ref={register} required />
                                    <Label htmlFor='forma_1'>Whatsapp</Label>
                                </FieldRadio> 
                                <FieldRadio>
                                    <input id="forma_2" name="forma"  value="Correo electrónico" type="radio" ref={register} required/>
                                    <Label htmlFor='forma_2'>Correo electrónico</Label>
                                </FieldRadio>  
                                <FieldRadio>
                                    <input  id="forma_3" name="forma"  value="Llamada telefónica" type="radio" ref={register} required/>
                                    <Label htmlFor='forma_3'>Llamada telefónica</Label>
                                </FieldRadio>
                                <FieldRadio>
                                    <input  id="forma_4" name="forma"  value="En persona en día de partido" type="radio" ref={register} required />
                                    <Label htmlFor='forma_4'>En persona en día de partido</Label>
                                </FieldRadio>  
                                <div>
                                    <br />
                                    <p>Por favor introduce el número al cual deseas que te contactemos</p>
                                    <textarea name="contacto_num" ref={register} required></textarea>
                                </div>                                                                    
                            </div>
                            <br /><br />
                            <Button type='submit' disabled={loadingProfileAttention}>Enviar</Button>
                            <br />

                        </StyledForm>

                    </Then>
                    <Else>
                        <AuthLayoutWrapper>

                            <div></div>
                            <h2 className="title">¡Enhorabuena!</h2>
                            <br />
                            <br />
                            <br />
                            <p>Tu cuenta para el portal ADSL ha sido creada exitosamente.</p>
                            <br/>
                            <p>A partir de este momento puedes hacer login con tu correo y password que definiste, para acceder a todos los beneficios que tu Abono ADSL tiene para ti.</p>
                            <br/>
                            <p>Para hacer login, haz click aquí.</p>
                            <br/>
                            <p>¡Gracias por ser parte del Atlético de San Luis!</p>
                        </AuthLayoutWrapper>
                    </Else>
                </If>
            </div>
        </StyledPage>
    )
};